import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Eyebrow, Reveal } from "@/components/Reveal";
import { useLang } from "@/i18n/LanguageContext";

export default function Faq() {
  const { t } = useLang();
  return (
    <section id="faq" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-12">
        <Reveal className="mb-12 text-center">
          <Eyebrow className="mb-5 justify-center">{t.faq.eyebrow}</Eyebrow>
          <h2 className="font-display text-4xl font-semibold leading-[1.05] text-cream sm:text-5xl">
            {t.faq.titleA} <span className="italic text-gold-grad">{t.faq.titleB}</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="rounded-3xl border border-gold/15 bg-navy2/50 px-6 sm:px-8" data-testid="faq-accordion">
            {t.faq.items.map((item, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-cream/10" data-testid={`faq-item-${i + 1}`}>
                <AccordionTrigger className="py-6 text-left font-display text-xl font-medium text-cream hover:text-gold hover:no-underline sm:text-2xl">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-sm leading-relaxed text-cream/65 sm:text-base">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
